module.exports = __webpack_public_path__ + "static/media/28-5.ade75e7b.mp3";